import { generateKey, GenerateFunction } from './common';
import { getShowKey } from './use-transify';

type TransifyFunction = (key: string, options: any) => string;

interface CommonConfig {
  t: TransifyFunction;
  project: string;
  isShowKey: boolean; // 是否显示key，为true时，始终显示，为false时取决于翻译工具
}

export function generateTransifyCommon(config: CommonConfig): GenerateFunction {
  if (!config || !config.project) {
    throw new Error('project is required!');
  }
  return function (label, namespace, options) {
    const isShowKey = getShowKey() || config.isShowKey;
    const computedKey = generateKey({ label, namespace, project: config.project });

    if (!computedKey) return '';
    if (isShowKey) return computedKey;

    // 如果返回的翻译结果和key相同，则说明未上传，默认显示label
    const res = config.t(computedKey, options);
    if (res === computedKey) {
      console.warn(`the key '${computedKey}' for label '${label}' is undefined.`);
      return label;
    }
    return res;

    // return config.t(computedKey, options);
  };
}
